export default __webpack_public_path__ + "static/media/elevate-lav-banner-3.fd2f7ef1.jpg";